import type { UiState } from "../products/types";

export function renderFilterPanel(categories: string[], queryState: UiState): string {
  return `
      <form class="control-panel" aria-label="Testergebnisse filtern und sortieren">
        <label for="categoryFilter">Produktgruppe</label>
        <select id="categoryFilter" name="categoryFilter">
          ${categories
            .map(
              (category) =>
                `<option value="${category}" ${category === queryState.category ? "selected" : ""}>${category}</option>`
            )
            .join("")}
        </select>

        <label for="maxOverall">Maximale Gesamtnote</label>
        <select id="maxOverall" name="maxOverall">
          <option value="5" ${queryState.maxOverall === "5" ? "selected" : ""}>Beliebige Note</option>
          <option value="3" ${queryState.maxOverall === "3" ? "selected" : ""}>3,0 oder besser</option>
          <option value="2.5" ${queryState.maxOverall === "2.5" ? "selected" : ""}>2,5 oder besser</option>
          <option value="2" ${queryState.maxOverall === "2" ? "selected" : ""}>2,0 oder besser</option>
        </select>

        <label for="sortBy">Sortieren nach</label>
        <select id="sortBy" name="sortBy">
          <option value="overall-asc" ${queryState.sortBy === "overall-asc" ? "selected" : ""}>Gesamtnote (beste zuerst)</option>
          <option value="overall-desc" ${queryState.sortBy === "overall-desc" ? "selected" : ""}>Gesamtnote (schlechteste zuerst)</option>
          <option value="price-asc" ${queryState.sortBy === "price-asc" ? "selected" : ""}>Preis (niedrig nach hoch)</option>
          <option value="price-desc" ${queryState.sortBy === "price-desc" ? "selected" : ""}>Preis (hoch nach niedrig)</option>
        </select>
      </form>
  `;
}
